import { createContext } from '@lyearn/core/utils/context';
import useSurveyEditor from '@/modules/corporate/modules/survey/views/SurveyEditor/hooks/useSurveyEditor';
import { UpdateSurveyInput } from '@/types/schema';

type UseSurveyEditorReturnType = ReturnType<typeof useSurveyEditor>;

type SurveyEditorContextType = Omit<
  UseSurveyEditorReturnType,
  | 'fetching'
  | 'error'
  | 'survey'
  | 'onClosePublishChangesDialog'
  | 'onPublishSubmit'
  | 'onPublish'
  | 'onRevertSuccess'
  | 'allowMinorVersionPublish'
> & {
  survey: UpdateSurveyInput;
};

export const [SurveyEditorProvider, useSurveyEditorContext] =
  createContext<SurveyEditorContextType>('SurveyEditor');
